import React from 'react';

const MarketPulzeLogo = ({ size = 36 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width={size} height={size}>
    <defs>
      <linearGradient id="bgGradL" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor:'#050d1a'}} />
        <stop offset="100%" style={{stopColor:'#0a1628'}} />
      </linearGradient>
      <linearGradient id="pulseGradL" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" style={{stopColor:'#00d4ff',stopOpacity:0.3}} />
        <stop offset="40%" style={{stopColor:'#00ff88'}} />
        <stop offset="70%" style={{stopColor:'#00d4ff'}} />
        <stop offset="100%" style={{stopColor:'#7b2fff',stopOpacity:0.8}} />
      </linearGradient>
      <linearGradient id="iconGradL" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor:'#00ff88'}} />
        <stop offset="50%" style={{stopColor:'#00d4ff'}} />
        <stop offset="100%" style={{stopColor:'#7b2fff'}} />
      </linearGradient>
      <filter id="glowL">
        <feGaussianBlur stdDeviation="4" result="blur" />
        <feMerge><feMergeNode in="blur"/><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <rect width="200" height="200" rx="40" fill="url(#bgGradL)" />
    <rect width="200" height="200" rx="40" fill="none" stroke="url(#iconGradL)" strokeWidth="2" opacity="0.5" />
    <g opacity="0.12">
      <rect x="25" y="130" width="20" height="50" fill="#00ff88" rx="4" />
      <rect x="52" y="105" width="20" height="75" fill="#00ff88" rx="4" />
      <rect x="79" y="115" width="20" height="65" fill="#00ff88" rx="4" />
      <rect x="106" y="85" width="20" height="95" fill="#00ff88" rx="4" />
      <rect x="133" y="95" width="20" height="85" fill="#00ff88" rx="4" />
      <rect x="160" y="70" width="20" height="110" fill="#00ff88" rx="4" />
    </g>
    <polyline points="18,120 40,120 55,72 75,155 95,95 112,95 130,50 148,150 162,100 175,100 185,80"
      fill="none" stroke="url(#pulseGradL)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" filter="url(#glowL)" />
    <circle cx="130" cy="50" r="8" fill="#00ff88" opacity="0.3" filter="url(#glowL)" />
    <circle cx="130" cy="50" r="5" fill="#00ff88" />
    <circle cx="130" cy="50" r="2.5" fill="#ffffff" />
  </svg>
);

export default MarketPulzeLogo;
